function call(type, url, callback) {
  const xmlhttp = new XMLHttpRequest();

  xmlhttp.onreadystatechange = () => {
    if (xmlhttp.readyState == XMLHttpRequest.DONE && xmlhttp.status == 200) {
      const data = xmlhttp.responseText;
      if (callback) callback(data);
    }
  };

  xmlhttp.open(type, url, true);
  xmlhttp.send();
}

function get(url, callback) {
  return call('GET', url, callback);
}

export { get };
